<template>
    <div
            class="hero 3xl:tw-max-w-[120rem] 2xl:tw-px-24  tw-items-center tw-w-full tw-h-full xl:tw-px-14 sm:tw-px-[5.62rem] sm:tw-py-10 tw-px-5 xl:tw-py-10 tw-py-5 tw-flex tw-flex-col tw-bg-lightest-gray tw-space-between"
            :style="primaryColorStyle"
    >
        <div class="hero-header 3xl:tw-max-h-[12.5rem] lg:tw-max-w-[75rem] tw-max-w-[25rem] md:tw-max-w-[51rem]  xl:tw-w-full xl:tw-max-w-[120rem] tw-w-full tw-flex tw-flex-row tw-justify-between">
            <div
                    v-if="companyLogo"
                    class="tw-max-w-[18.75rem] tw-max-h-[12.5rem] grow-0"
            >
                <img
                        class="sm:tw-max-w-[18.75rem] sm:tw-max-h-[12.5rem] tw-max-w-[11.25rem] tw-max-h-[7.5rem] grow-0"
                        :src="companyLogo"
                        alt="image desc"
                />
            </div>
            <lp-primary-button
                    v-if="isDesktop"
                    content="Sign In"
                    :click-callback="btnActionCallback"
                    :base-color="landingPage.primaryColor"
            />
            <lp-secondary-button
                    v-else
                    content="Sign In"
                    :click-callback="btnActionCallback"
                    :base-color="landingPage.primaryColor"
            />
        </div>
        <div class="hero-content-wrapper 2xl:tw-mt-16 xl:tw-mt-8 tw-w-full tw-flex xl:tw-flex-row tw-h-full tw-flex-col tw-justify-between tw-items-center">
            <div class="hero-content md:tw-p-0 md:tw-mt-[3rem] lg:tw-items-start lg:tw-mt-[2rem] 3xl:tw-max-w-[51rem] 2xl:tw-max-w-[38rem] xl:tw-items-start xl:tw-p-0 xl:tw-max-w-[33rem] tw-items-center tw-pb-0 tw-pt-6 tw-w-full tw-flex tw-flex-col tw-justify-between tw-py-12">
                <div class="hero-title-wrapper xl:tw-h-full xl:tw-justify-between tw-flex tw-flex-col tw-justify-center tw-items-start tw-pt-0 tw-w-full">
                    <div class="title tw-h-full tw-w-full md:tw-justify-center tw-flex tw-flex-col tw-justify-between">
                        <span class="md:tw-mb-[1.75rem] lg:tw-mb-[2.25rem] 3xl:tw-text-[6rem] 3xl:tw-leading-[6.25rem] 3xl:tw-mb-[2.25rem] xl:tw-mb-[1.6rem] 2xl:tw-text-[4rem] 2xl:tw-leading-[4.25rem] sm:tw-text-[3.25rem] sm:tw-leading-[3.25rem] md:tw-text-[4rem] md:tw-leading-[4.25rem] xl:tw-text-[3.75rem] tw-text-4xl xl:tw-leading-[3.75rem] tw-leading-10 tw-font-poppins tw-font-semibold tw-text-[#161C2D]">
                            Homeownership<br> made easy.
                        </span>
                        <p class="subtitle md:tw-mb-[3.25rem] md:tw-leading-[2rem] lg:tw-mb-[4.25rem] 3xl:tw-text-[2rem] 3xl:tw-leading-[3rem] 3xl:tw-mb-[3.25rem] xl:tw-text-[1.75rem] xl:tw-leading-[2.75rem] md:tw-text-[1.5rem] tw-text-xl tw-leading-[1.8rem] tw-font-sans tw-font-normal tw-text-[#444]">
                            Claim your private homeowner hub<br> to manage your home in one place.
                        </p>
                    </div>
                    <div
                            class="address-search-wrapper"
                            :class="!isCustomAddressSelected ?
                                'md:tw-mt-0 lg:tw-mt-0 3xl:tw-max-w-[48rem] md:tw-max-w-[48rem] md:tw-flex-row md:tw-justify-between tw-max-h-44 tw-rounded-[0.62rem] tw-bg-white tw-flex xl:tw-flex-row tw-flex-col lg:tw-shadow-[0px_53.6px_52.607px_-22.83px_rgba(22,28,45,0.50)] tw-w-full xl:tw-max-w-[36rem] tw-items-center tw-gap-4 tw-p-4 tw-mt-5'
                                : 'tw-flex tw-flex-col tw-gap-4 tw-p-6 md:tw-p-8 tw-border tw-border-gray-200 tw-rounded-xl lg:tw-shadow-[0px_53.6px_52.607px_-22.83px_rgba(22,28,45,0.50)]'"
                    >
                        <div
                                class="address-type-ahead-wrapper"
                                :class="{ 'tw-w-full md:tw-max-w-[32.625rem] tw-max-h-16 tw-flex md:tw-w-[32.625rem] xl:tw-max-w-[32.625rem] tw-h-[4rem] tw-items-center tw-gap-4 tw-rounded-[0.64rem] tw-border tw-border-[#C3C5C9] tw-bg-white': !isCustomAddressSelected }"
                                :style="!isCustomAddressSelected ? { borderRadius: '0.64rem', border: '1.28px solid #C3C5C9' } : {}"
                        >
                            <custom-address-type-ahead
                                    id="custom-address-hero"
                                    swap-text-class="address-swap"
                                    search-label=""
                                    address-ref="addressTypeAhead"
                                    city-state-label="City & State"
                                    zip-label="ZIP Code"
                                    street-label="Street Address"
                                    ref="customAddressTypeAhead"
                                    placeholder="Enter your home address"
                                    :value="address"
                                    :errors="errors"
                                    :class="{'border-danger': hasAddressError}"
                                    :show-enter-manually-button="false"
                                    :has-focusable-state="false"
                                    has-custom-before-slot
                                    prefill-address
                                    @is-zip-code-valid="isZipCodeValid = $event"
                                    @select-address="handleAddressInput"
                                    @is-custom-address-selected="onCustomAddressSelected"
                            >

                                <template #before>
                                    <div class="tw-w-[2.1rem] tw-h-[2.4rem] tw-flex tw-justify-center tw-items-center">
                                        <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="26"
                                                height="34"
                                                viewBox="0 0 26 34"
                                                fill="none"
                                        >
                                            <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M12.9307 0.418884C6.76575 0.418884 0.388306 5.07138 0.388306 12.8568C0.388306 21.1133 11.9177 32.6418 12.4091 33.1283C12.5471 33.2659 12.7352 33.3427 12.9307 33.3427C13.1262 33.3427 13.3144 33.2659 13.4523 33.1283C13.9437 32.6418 25.4731 21.1133 25.4731 12.8568C25.4731 5.07138 19.0957 0.418884 12.9307 0.418884ZM12.9308 17.2466C10.4895 17.2466 8.50408 15.2778 8.50408 12.8568C8.50408 10.4358 10.4895 8.46696 12.9308 8.46696C15.3721 8.46696 17.3575 10.4358 17.3575 12.8568C17.3575 15.2778 15.3721 17.2466 12.9308 17.2466Z"
                                                    :fill="landingPage.primaryColor || '#064789'"
                                            />
                                        </svg>
                                    </div>
                                </template>
                            </custom-address-type-ahead>

                            <form-errors
                                    :errors="errors"
                                    field="address"
                            />

                            <div
                                    v-if="isCustomAddressSelected"
                                    class="d-flex justify-content-center pt-2"
                            >
                                <button
                                        aria-label="Cancel"
                                        class="cancel-btn tw-bg-white tw-border-none tw-font-poppins tw-font-semibold tw-px-4 tw-py-2 tw-mr-4 tw-rounded-md tw-transition tw-duration-200 hover:tw-bg-gray-100"
                                        @click="resetAddress"
                                >
                                    Cancel
                                </button>
                                <button
                                        aria-label="Claim my home"
                                        class="claim-my-hub-btn tw-border-none tw-w-auto tw-px-6 tw-h-12 tw-rounded-md tw-bg-[#064789] tw-flex tw-justify-center tw-items-center tw-text-white tw-font-poppins tw-font-semibold tw-text-base"
                                        :style="{ background: landingPage.primaryColor, opacity: !isZipCodeValid ? '0.6' : '' }"
                                        @click="onCustomAddressClaimMyHome"
                                >
                                    Claim my home
                                </button>
                            </div>
                        </div>
                        <button
                                v-if="!isCustomAddressSelected"
                                aria-label="Claim my home"
                                class="claim-my-hub-btn tw-border-none md:tw-max-w-[12.8rem] tw-max-h-16 tw-w-full md:tw-w-full tw-rounded-lg tw-bg-[#064789] xl:tw-w-[12.8125rem] tw-h-16 tw-flex tw-justify-center tw-items-center tw-text-white tw-font-poppins tw-font-bold tw-text-xl"
                                :style="{ background: landingPage.primaryColor }"
                                @click="handleClaimMyHomeClick"
                        >
                            Claim my home
                        </button>
                    </div>
                </div>
                <div class="hero-footer-wrapper md:tw-mt-[4rem] md:tw-mb-[4.6rem] lg:tw-mt-[5rem] lg:tw-mb-[5.6rem] xl:tw-mt-16 md:tw-max-w-[48rem] md:tw-w-full tw-flex tw-flex-col tw-justify-between tw-h-16 xl:tw-w-full tw-w-full tw-max-w-[24rem] tw-mt-[3.75rem] tw-mb-[2.5rem]">
                    <div class="footer-bar tw-h-[0.062rem] tw-w-40 tw-bg-[#444] tw-opacity-35 tw-mx-auto tw-ml-0"></div>
                    <span
                            v-if="isDesktop"
                            class="footer-text tw-text-[#444] tw-text-xl tw-font-sans tw-font-normal tw-w-[48.7rem]"
                    >
                        It's like a patient portal, for your home.
                    </span>
                    <span
                            v-else
                            class="footer-text tw-text-[#444] tw-text-base tw-leading-6 tw-font-sans tw-font-normal xl:tw-w-[48.7rem]"
                    >
                        It's like a patient portal, for your home.
                    </span>
                </div>
            </div>
            <div
                    class="3xl:tw-w-[51.3rem] 3xl:tw-bottom-10 2xl:tw-w-[40rem] 2xl:tw-mb-[5.5rem] 2xl:tw-bottom-6 xl:tw-bottom-24 xl:tw-w-[33rem] lg:tw-w-[51.3rem] md:tw-w-[37rem] tw-w-[21rem] tw-aspect-[16/9] tw-relative tw-flex-shrink-0 tw-rounded-[1.25rem] tw-bg-lightgray tw-bg-cover tw-bg-center"
            >
                <iframe
                        class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-rounded-[1.25rem]"
                        src="https://player.vimeo.com/video/1033105845?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                        frameborder="0"
                        allow="autoplay; fullscreen"
                        allowfullscreen
                >
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
import HOHAddressMixin from "../Home/HomeTypes/HomeOwnershipHome/HOHAddressMixin";
import isMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
import {myProjectsUrl, redirectTo} from "../../helpers/externalRoutes";
import LpPrimaryButton from "./Buttons/LpPrimaryButton.vue";
import LpSecondaryButton from "./Buttons/LpSecondaryButton.vue";
import showNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
import claimMyHomeMixin from "./claimMyHomeMixin";
import FormErrors from '@milestoneslabs/milestones-ui-kit/src/components/FormErrors/FormErrors';
import CustomAddressTypeAhead from
    "@milestoneslabs/milestones-ui-kit/src/components/CustomAddressTypeAhead/CustomAddressTypeAhead";
import AddressAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/AddressAppResource";

export default {
    name: 'LandingPageHero',
    components: {
        LpPrimaryButton,
        LpSecondaryButton,
        CustomAddressTypeAhead,
        FormErrors,
    },
    mixins: [
        HOHAddressMixin,
        isMobileMixin,
        showNotificationMixin,
        claimMyHomeMixin,
    ],
    props: {
        landingPage: {
            type: LandingPageAppResource,
            required: true,
        },
    },
    data() {
        return {
            address: new AddressAppResource({}),
            errors: {},
            isZipCodeValid: false,
            isCustomAddressSelected: false
        };
    },
    computed: {
        companyLogo() {
            return (this.landingPage.organizationLogo || {}).publicStorageUrl || null;
        },
    },
    methods: {
        btnActionCallback() {
            if (Boolean(this.authUser?.uuid) && this.landingPage.userUuid === this.authUser.uuid) {
                this.showNotification({
                    message: 'You can not create a hub from your own Landing Page! Please log in as another user!',
                    type: 'error',
                });
                return;
            }

            return redirectTo(myProjectsUrl({
                landingPageUuid: this.landingPage.uuid,
                brandedLogin: window.brandedLogin,
                type: this.projectType,
            }));
        }
    }
};
</script>
<style lang="scss">
.hero {
    .hero-content-wrapper {
        .hero-content {
            .hero-title-wrapper {
                .address-search-wrapper {
                    .address-type-ahead-wrapper {
                        .custom-address {
                            @apply tw-font-poppins;
                            & label {
                                @apply tw-text-[#595959] tw-font-bold;
                            }
                            & #company-second-street-input {
                                @apply tw-mb-4;
                            }
                            & .form-group input:not(.type-ahead__input) {
                                @apply tw-border tw-border-[#C3C5C9] tw-rounded-lg tw-bg-white tw-px-4 tw-text-base tw-font-poppins tw-text-gray-900 tw-transition tw-duration-200;
                            }
                            & .form-group input:not(.type-ahead__input):focus {
                                border-color: var(--landing-page-primary-color);
                                box-shadow: 0 0 0 1px var(--landing-page-primary-color);
                            }
                            .address-swap {
                                color: var(--landing-page-primary-color) !important;
                                &.text-address {
                                    @apply tw-pt-4 tw-pb-4 tw-mt-0;
                                }
                            }
                            .company-form-group {
                                @apply tw-mb-0;
                                .type-ahead {
                                    @apply tw-flex-grow tw-p-4;
                                    .input-group {
                                        @apply tw-flex tw-justify-between tw-items-center;
                                        .type-ahead__input {
                                            @apply tw-text-[#595959] tw-text-base tw-font-normal tw-leading-[1.92rem] tw-border-none;
                                            padding-left: 1rem !important;
                                        }
                                    }
                                }
                            }
                            .city-state-group {
                                @apply tw-relative tw-w-full;
                                #city-state-dropdown {
                                    @apply tw-absolute tw-rounded-xl tw-min-w-full tw-left-0 tw-right-0 tw-z-10 tw-mt-2;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
